import { render } from "./ProfileCampaigns.vue?vue&type=template&id=1725a030"
import script from "./ProfileCampaigns.vue?vue&type=script&lang=js"
export * from "./ProfileCampaigns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__